import { PureComponent } from "react";
import { StyledReview } from "./review.scss";

export default class Review extends PureComponent {
  constructor(props) {
    super(props);
  }

  renderReviewContent() {
    const { reviewContent } = this.props;

    return reviewContent.map((line, index) => (
      <div className="line" key={index} dangerouslySetInnerHTML={{ __html: line }} />
    ));
  }

  render() {
    const { reviewerName, reviewedOn } = this.props;

    return (
      <StyledReview className="review-component">
        <div className="review-content">{this.renderReviewContent()}</div>
        <div className="reviewer-name">{reviewerName}</div>
        <div className="reviewed-on">Reviewed on {reviewedOn}</div>
      </StyledReview>
    );
  }
}

Review.defaultProps = {
  reviewContent: []
};
